import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import CommonButton from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import UserFormModal from '../user-form-modal/UserFormModal';
import { customerAddUserFormYupValidation } from '../user-form-modal/validation';
import { addCustomerToCompany } from '../../../../redux/customers/customersActions';

import scss from './AddUserButton.module.scss';

const AddUserButton = () => {
  const { t } = useTranslation('customers');
  const dispatch = useDispatch();
  const { id } = useParams();

  const [isAddUserModalOpen, setIsAddModalOpen] = useState(false);

  const handleOpenAddUserModal = useCallback(() => {
    setIsAddModalOpen(true);
  }, []);

  const handleCloseAddUserModal = useCallback(() => {
    setIsAddModalOpen(false);
  }, []);

  const handleAddUser = async (values) => {
    await dispatch(addCustomerToCompany({ companyId: id, ...values }));
  };

  return (
    <div className={scss.wrapper}>
      <CommonButton styleColor='secondary' className={scss.button} maxWidth={140} onClick={handleOpenAddUserModal}>
        <Icon icon={ICONS.CirclePlus} />
        {t('addUser')}
      </CommonButton>

      <UserFormModal
        isOpen={isAddUserModalOpen}
        onSubmit={handleAddUser}
        onCancel={handleCloseAddUserModal}
        onClose={handleCloseAddUserModal}
        formTitle={t('addUser')}
        submitButtonText={t('addUser')}
        validation={customerAddUserFormYupValidation}
      />
    </div>
  );
};

export default memo(AddUserButton);
